module.exports = __webpack_public_path__ + "img/dianzan.bd04134f.png";